import { useTranslation } from "react-i18next";
import React, { useState } from "react";

import { ChapterSkillsStatsDto, LessonSkillStatsDto } from "../../interfaces";
import { SkillsStatisticsPage } from "./SkillsStatisticsPage";
import { SkillsPage } from "./SkillsPage";

type TProps = { subjectId: string };
export const SkillsLayoutPage: React.FC<TProps> = ({ subjectId }) => {
  //#region hooks
  const { t, i18n } = useTranslation();
  //#endregion

  //#region internal state
  const [page, setPage] = useState<number>(1);
  const [selectedChapterSkillsStats, setSelectedChapterSkillsStats] =
    useState<ChapterSkillsStatsDto | null>(null);
  const [selectedLessonSkillsStats, setSelectedLessonSkillsStats] =
    useState<LessonSkillStatsDto | null>(null);
  //#endregion

  document.title = `${t("documentTitle", { pageName: "skills" })}`;

  //#region effects
  // useEffect(() => {
  //   dispatch(getChaptersSkillsStats(subjectId, history));
  // }, [subjectId]);

  //#endregion

  //#region handlers

  const onViewSkills = (
    chapter: ChapterSkillsStatsDto,
    lesson: LessonSkillStatsDto
  ) => {
    setPage(2);
    setSelectedChapterSkillsStats(chapter);
    setSelectedLessonSkillsStats(lesson);
  };
  //#endregion

  const getHeader = () => {
    try {
      return (
        <React.Fragment>
          <span className="cursor-pointer" onClick={() => setPage(1)}>
            {t("skills")}
          </span>
          {i18n.language === "ar" ? (
            <i className="ri-arrow-left-s-line align-bottom text-muted"></i>
          ) : (
            <i className="ri-arrow-right-s-line align-bottom text-muted"></i>
          )}
          <span className="text-muted">
            {i18n.language === "ar"
              ? selectedChapterSkillsStats?.name.ar
              : selectedChapterSkillsStats?.name.en}
          </span>
          {i18n.language === "ar" ? (
            <i className="ri-arrow-left-s-line align-bottom text-muted"></i>
          ) : (
            <i className="ri-arrow-right-s-line align-bottom text-muted"></i>
          )}
          <span className="text-muted">
            {i18n.language === "ar"
              ? selectedLessonSkillsStats?.name.ar
              : selectedLessonSkillsStats?.name.en}
          </span>
        </React.Fragment>
      );
    } catch (exception: any) {
      return t("skills");
    }
  };

  //#endregion

  return (
    <React.Fragment>
      {page === 1 && (
        <SkillsStatisticsPage
          subjectId={subjectId}
          onViewSkills={onViewSkills}
        />
      )}
      {page === 2 && selectedLessonSkillsStats && (
        <SkillsPage
          lessonId={selectedLessonSkillsStats?.id}
          header={getHeader()}
        />
      )}
    </React.Fragment>
  );
};
